/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { ITextBlockViewProps } from '@msdyn365-commerce-modules/text-block';
import { ITextBlockProps } from '../definition-extensions/text-block.ext.props.autogenerated';
import { replaceAccountToken } from '../../../utils/replaceAccountToken';

const TextBlockView: React.FC<ITextBlockViewProps & ITextBlockProps<{}>> = props => {
    const accountNumber = props.context.request.user.customerAccountNumber;
    const accountToken = props.resources?.accountToken ?? '{account}';
    const paragraphWithAccount = replaceAccountToken(props.config.paragraph, accountToken, accountNumber);

    const renderedParagraph = paragraphWithAccount ? (
        <Msdyn365.RichTextComponent text={paragraphWithAccount} className='ms-text-block__text' />
    ) : null;
    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {renderedParagraph}
        </div>
    );
};

export default TextBlockView;
